import {LiveImage} from "./image";

export class Banner {

    protected _image: LiveImage;

    get image() {
        return this._image;
    }

    get url():string {
        return this._image.url;
    }

    static fromFile(file:LiveImage):Promise<Banner> {
        let res = new Banner();
        res._image = file;

        return Promise.resolve(res);
    }
}



// WEBPACK FOOTER //
// ./src/api/banner.ts